import {useEffect, useState} from 'react';
import axios from 'axios';
import {useBaseUrl} from '../../../utils/utils';

const getStoredToken = () =>
    localStorage.getItem('token') || localStorage.getItem('authToken') || sessionStorage.getItem('token') || '';

/** Shared fetch-on-mount for all six admin dashboards - same
 * auth/error/loading handling everywhere rather than six copies of it. */
export function useDashboardData<T>(path: string) {
    const baseUrl = useBaseUrl();
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);

        const token = getStoredToken();
        axios.get(`${baseUrl}${path}`, {
            headers: token ? {Authorization: `Bearer ${token}`} : {},
        }).then((res) => {
            if (cancelled) return;
            if (res.data?.status === 'success') {
                setData(res.data.data);
            } else {
                setError(res.data?.message || 'Could not load dashboard data.');
            }
        }).catch((err) => {
            if (cancelled) return;
            setError(err?.response?.data?.message || 'Could not load dashboard data.');
        }).finally(() => {
            if (!cancelled) setLoading(false);
        });

        return () => {
            cancelled = true;
        };
    }, [baseUrl, path]);

    return {data, loading, error};
}
